/*
 * AppConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */


export const LOGIN_SUCCESS = 'app.LOGIN_SUCCESS';
export const LOGOUT_SUCCESS = 'app.LOGOUT_SUCCESS';
export const API_SUCCESS = 'app.API_SUCCESS';
export const API_FAIL = 'app.API_FAIL';
export const SET_SELECTED_POLICY_ID = 'app.SELECTED_POLICY_ID';
export const SET_ERROR = 'app.SET_ERROR';
export const CLEAR_ERROR = 'app.CLEAR_ERROR';
export const FNOL_REPORT_DATE_VALIDATION_STATUS = 'app.FNOL_REPORT_DATE_VALIDATION_STATUS';
export const SET_VALIDATE_STEP = 'app.SET_VALIDATE_STEP';
export const SET_MEDICAL_AUTHORITY_FORM_LINK = 'app.SET_MEDICAL_AUTHORITY_FORM_LINK';
export const SET_MEDICAL_CERTIFICATE_FORM_LINK = 'app.SET_MEDICAL_CERTIFICATE_FORM_LINK';
export const SET_CLAIM_TYPES = 'app.SET_CLAIM_TYPES';
export const SET_CHILD_BENEFITS = 'app.SET_CHILD_BENEFITS';
export const SET_VALIDATION_REPORT_DATE_ERROR = 'app.SET_VALIDATION_REPORT_DATE_ERROR';
export const DEFAULT_LOCALE = 'en';
export const SET_JSON_VERSION = 'app.SET_JSON_VERSION';
export const SET_INSURED_LIST = 'app.SET_INSURED_LIST';
export const SET_CLAIM_PAYMENT_VERSION = 'app.SET_CLAIM_PAYMENT_VERSION';
export const SET_IS_LINKED_COVER = 'app.SET_IS_LINKED_COVER';
export const SET_INCIDENT_DATE = 'app.SET_INCIDENT_DATE';
export const SET_SHOW_ELECTRONIC_CONSENT = 'app.SET_SHOW_ELECTRONIC_CONSENT';
export const SET_DECLARATION_CLAIMS_ADMIN_COMPANY_NAME = 'app.SET_DECLARATION_CLAIMS_ADMIN_COMPANY_NAME';
export const SET_TPA_NAME = 'app.SET_TPA_NAME';
export const SET_CARRIER_NAME = 'app.SET_CARRIER_NAME';
export const SET_EMAIL_ADDRESS = 'app.SET_EMAIL_ADDRESS';
export const SET_PHONE_NUMBER = 'app.SET_PHONE_NUMBER';
export const SET_CLIENT_ID = 'app.SET_CLIENT_ID';
export const SET_SHOW_REQUIRE_DOCUMENT = 'app.SET_SHOW_REQUIRE_DOCUMENT';
export const SET_IS_CLAIM_GROUP_ALLOWED = 'app.SET_IS_CLAIM_GROUP_ALLOWED';
export const SET_CELLCAPTIVE_COUNTRY_ID = 'app.SET_CELLCAPTIVE_COUNTRY_ID';
export const SET_INIT_CLAIM_TYPES_SUCCESS = 'app.SET_INIT_CLAIM_TYPES_SUCCESS';
export const SET_ZURICH_UHC = 'app.SET_ZURICH_UHC';
export const SET_POLICY_PURCHASE_DATE = 'app.SET_POLICY_PURCHASE_DATE';
export const SET_POLICY_EFFECTIVE_DATE = 'app.SET_POLICY_EFFECTIVE_DATE';
export const SET_POLICY_TERMINATION_DATA = 'app.SET_POLICY_TERMINATION_DATA';
export const SET_CLAIMANT_ID = 'app.SET_CLAIMANT_ID';
export const SET_GUARDIAN_CLIENT_ROLES = 'app.SET_GUARDIAN_CLIENT_ROLES';
export const SET_APPSURE_INSTANCE_SCTI = 'app.SET_APPSURE_INSTANCE_SCTI';
export const SET_POLICY_TYPE_CODE = 'app.SET_POLICY_TYPE_CODE';
export const SET_SPECIFIED_ITEMS = 'app.SET_SPECIFIED_ITEMS';
export const SET_POLICY_CANCELLED = 'app.SET_POLICY_CANCELLED';
export const SET_SHOW_TRAWICK_FNOL_REFACTORING = 'app.SET_SHOW_TRAWICK_FNOL_REFACTORING';
export const SET_EVENT_DESCRIPTION_LIMIT = 'app.SET_EVENT_DESCRIPTION_LIMIT';




// WEBPACK FOOTER //
// ./app/containers/App/constants.js